<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane>
        <span slot="label"
          ><i class="fas fa-database"></i> THÔNG TIN CHUNG</span
        >
        <ThongTinChung />
      </el-tab-pane>
      <!-- <el-tab-pane>
        <span slot="label"><i class="fas fa-dollar-sign"></i> DOANH THU</span>
        <DoanhThu />
      </el-tab-pane> -->
      <!-- <el-tab-pane>
        <span slot="label"><i class="fas fa-analytics"></i> MARKETING</span>
        <div class="card">
          <div class="card-header"><h3>Top 10 người bán hàng trong tháng</h3></div>
          <TopBanHang />
        </div>
      </el-tab-pane> -->
      <!-- <el-tab-pane>
        <span slot="label"><i class="fas fa-ad"></i> QUẢNG CÁO</span>
        Route
      </el-tab-pane> -->
      <!-- <el-tab-pane>
        <span slot="label"><i class="el-icon-share"></i> MẠNG XÃ HỘI</span>
        Route
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>
<script>
import ThongTinChung from "./ThongTinChung.vue";
import TopBanHang from "../../admin/Chart/TopBanHang.vue";
import DoanhThu from "../DoanhThu/DoanhThu.vue";
export default {
  components: {
    ThongTinChung,
    TopBanHang,
    DoanhThu,
  },
};
</script>
<style lang=""></style>
